import { defineStore } from 'pinia';

export const piniaFilterStore = defineStore('filters', {
  state: () => ({
    filterData: null as Record<string, any> | null
  }),
  actions: {
    setLocationData(data: Record<string, any>) {
      this.filterData = data;
    }
  }
});
